import { assert } from 'common/helpers'
import type { ProjectId } from 'common/types'
import { useParams } from 'react-router-dom'

export const useProjectIdFromUrl = (): ProjectId => {
  const url = new URLSearchParams(window.location.search)
  const projectIdFromUrl = url.get('projectId')
  const { projectId: projectIdFromRouter } = useParams()
  const projectId = projectIdFromUrl || projectIdFromRouter

  assert(!!projectId, 'ProjectId is not defined in Url')

  return projectId
}
